<template lang="pug">
#AdvancedSearch
  .container-fluid
    .row.py-5.d-flex.justify-content-center.align-items-center
      .col-12.col-md-11
        .group.mb-0
          input(
            type="text",
            required,
            v-model="search",
            @input="filterPublications()"
          )
          span.highlight
          span.bar
          label Ingresa palabras o frases para buscar dentro de la base
        //b-button.pl-0.advanced-search-button.d-flex.flex-row.align-items-center(
          variant="link",
          :class="showCollapse ? 'collapsed' : null",
          :aria-expanded="showCollapse ? 'true' : 'false'",
          aria-controls="collapse-1"
          )
          i.fas(
            :class="showCollapse ? 'fa-minus' : 'fa-plus'",
            @click="showCollapse = !showCollapse"
          )
          span(@click="showCollapse = !showCollapse") &nbsp;&nbsp;Búsqueda avanzada
          download-csv.ml-3(
            :data="filteredPublications",
            :name="`Publicaciones_DDLD.csv`"
          )
            i.fas.fa-download.my-1
        b-collapse#collapse-1.mt-2(v-model="showCollapse")
          b-card
            .row
              .col-10
                p.small Selecciona un valor en ambos filtros
                .row
                  .col-12.col-lg-4.my-3
                    .select
                      select.select-text(
                        required,
                        v-model="filterSelection.tema",
                        @change="handleFilters(filterSelection.tema, 'Tema')"
                      )
                        option(:value="null", selected)
                        template(v-for="(tema, i) in temas")
                          option(:value="tema") {{ tema }}
                      span.select-highlight
                      span.select-bar
                      label.select-label Tema

                  .col-12.col-lg-4.my-3
                    .select
                      select.select-text(
                        required,
                        v-model="filterSelection.medio",
                        @change="handleFilters(filterSelection.medio, 'Medio')"
                      )
                        option(:value="null", selected)
                        template(v-for="(medio, i) in medios")
                          option(:value="medio") {{ medio }}
                      span.select-highlight
                      span.select-bar
                      label.select-label Medio

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(required v-model="filterSelection.formato" @change="handleFilters(filterSelection.formato, 'Formato')")
                        option(:value="null" selected)
                        template(v-for="(formato, i) in formatos")
                          option(:value="formato") {{formato}}
                      span.select-highlight
                      span.select-bar
                      label.select-label Formato

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(
                        required,
                        v-model="filterSelection.etiquetas",
                        @change="handleFilters(filterSelection.etiquetas, 'Etiquetas')"
                      )
                        option(:value="null", selected)
                        template(v-for="(etiqueta, i) in etiquetas")
                          option(:value="etiqueta") {{ etiqueta }}
                      span.select-highlight
                      span.select-bar
                      label.select-label Etiqueta

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(
                        required,
                        v-model="filterSelection.plataforma",
                        @change="handleFilters(filterSelection.plataforma, 'Plataforma')"
                      )
                        option(:value="null", selected)
                        template(v-for="(plataforma, i) in plataformas")
                          option(:value="plataforma") {{ plataforma }}
                      span.select-highlight
                      span.select-bar
                      label.select-label Plataforma

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(required v-model="filterSelection.periodista" @change="handleFilters(filterSelection.periodista, 'Periodista')")
                        option(:value="null" selected)
                        template(v-for="(periodista, i) in periodistas")
                          option(:value="periodista") {{periodista}}
                      span.select-highlight
                      span.select-bar
                      label.select-label Periodista

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(
                        required,
                        v-model="filterSelection.municipio",
                        @change="handleFilters(filterSelection.municipio, 'Municipio')"
                      )
                        option(:value="null", selected)
                        template(v-for="(municipio, i) in municipios")
                          option(:value="municipio") {{ municipio }}
                      span.select-highlight
                      span.select-bar
                      label.select-label Municipio

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(
                        required,
                        v-model="filterSelection.estado",
                        @change="handleFilters(filterSelection.estado, 'Estado')"
                      )
                        option(:value="null", selected)
                        template(v-for="(estado, i) in estados")
                          option(:value="estado") {{ estado }}
                      span.select-highlight
                      span.select-bar
                      label.select-label Estado

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(required v-model="filterSelection.presidente" @change="handleFilters(filterSelection.presidente, 'Presidente municipal', 'presidente')")
                        option(:value="null" selected)
                        template(v-for="(presidenteMunicipal, i) in presidenteMunicipals")
                          option(:value="presidenteMunicipal") {{presidenteMunicipal}}
                      span.select-highlight
                      span.select-bar
                      label.select-label Presidente Municipal

                  //.col-12.col-lg-4.my-3
                    .select
                      select.select-text(required v-model="filterSelection.partido" @change="handleFilters(filterSelection.partido, 'Partido político Presidente municipal', 'partido')")
                        option(:value="null" selected)
                        template(v-for="(partidoPolitico, i) in partidoPoliticos")
                          option(:value="partidoPolitico") {{partidoPolitico}}
                      span.select-highlight
                      span.select-bar
                      label.select-label Partido Político

              .col-2
                i.fas.fa-greater-than.advanced-search.mt-3.mt-md-5(
                  @click="showCollapse = !showCollapse"
                )

        b-pagination.mt-4(
          v-if="filteredPublications.length > 0",
          v-model="currentPage",
          :total-rows="rows",
          :per-page="perPage",
          size="sm",
          align="fill",
          aria-controls="table"
        )
        b-table#table(
          v-if="filteredPublications.length > 0",
          :items="filteredPublications",
          :fields="fields",
          :per-page="perPage",
          :current-page="currentPage",
          fixed,
          sticky-header,
          small,
          bordered,
          hover,
          responsive,
          stacked="md",
          @row-clicked="goToPublication",
          :busy="isLoading"
        )
        .text-center.my-2(v-if="isLoading")
          strong Cargando...
            br
            br
          b-spinner.align-middle(type="grow")
        p.mt-3.ml-4(v-if="filteredPublications.length == 0 && !isLoading") Sin resultados
</template>

<script>
import * as _ from "lodash";

export default {
  name: "AdvancedSearch",
  data() {
    return {
      showCollapse: false,
      perPage: 10,
      currentPage: 1,
      fields: [
        "Título",
        {
          key: "Tema"/*,
          formatter: (value) => value.join(", "),*/
        },
        "Medio",
        "Formato",
        "Etiquetas",
        {
          key: "Plataforma"/*,
          formatter: (value) => value.join(", "),*/
        },
        {
          key: "FDP",
          label: "Publicado",
        },
        "Periodista" /* 'Archivo', 'Link',*/,
        "Municipio",
        "Estado",
        "Presidente municipal",
        {
          key: "Partido político Presidente municipal",
          label: "Partido político",
        },
      ],
      search: "",
      searchedPublications: [],
      filteredPublications: [],
      csvData: [],
      temas: [],
      medios: [],
      formatos: [],
      etiquetas: [],
      plataformas: [],
      periodistas: [],
      municipios: [],
      estados: [],
      presidenteMunicipals: [],
      partidoPoliticos: [],
      selectedTema: null,
      selectedMedio: null,
      selectedFormato: null,
      selectedEtiqueta: null,
      selectedPlataforma: null,
      selectedPeriodista: null,
      selectedMunicipio: null,
      selectedEstado: null,
      selectedPresidenteMunicipal: null,
      selectedPartidoPolitico: null,
      filterSelection: {},
      isLoading: false,
    };
  },
  computed: {
    selectedPublication: {
      get() {
        return this.$store.state.selectedPublication;
      },
      set(newValue) {
        this.$store.state.selectedPublication = newValue;
      },
    },
    allPublications() {
      return this.$store.state.allPublications;
    },
    rows() {
      return this.filteredPublications.length;
    },
  },
  methods: {
    getFilterOptions() {
      this.temas = _.filter(
        _.uniq(this.searchedPublications.map((p) => p.Tema[0])),
        (o) => o !== ""
      ).sort();
      this.medios = _.filter(
        _.uniq(this.searchedPublications.map((p) => p.Medio)),
        (o) => o !== ""
      ).sort();
      this.formatos = _.filter(
        _.uniq(this.allPublications.map((p) => p.Formato)),
        (o) => o !== ""
      ).sort();
      this.etiquetas = _.filter(
        _.uniq(
          _.flattenDeep(this.allPublications.map((p) => p.Etiquetas.split("/")))
        ),
        (o) => o !== ""
      ).sort();
      this.plataformas = _.filter(
        _.uniq(this.allPublications.map((p) => p.Plataforma[0])),
        (o) => o !== ""
      ).sort();
      this.periodistas = _.filter(
        _.uniq(this.allPublications.map((p) => p.Periodista)),
        (o) => o !== ""
      ).sort();
      this.municipios = _.filter(
        _.uniq(this.allPublications.map((p) => p.Municipio)),
        (o) => o !== ""
      ).sort();
      this.estados = _.filter(
        _.uniq(this.allPublications.map((p) => p.Estado)),
        (o) => o !== ""
      ).sort();
      this.presidenteMunicipals = _.filter(
        _.uniq(this.allPublications.map((p) => p["Presidente municipal"])),
        (o) => o !== ""
      ).sort();
      this.partidoPoliticos = _.filter(
        _.uniq(
          this.allPublications.map(
            (p) => p["Partido político Presidente municipal"]
          )
        ),
        (o) => o !== ""
      ).sort();

      this.csvData = _.map(this.filteredPublications, function (c) {
        return _.omit(c, ["dayNumber"]);
        //return _.omit(c, ['dayNumber', 'weekStart', 'month', 'Amazon file', 'Texto']);
      });
    },
    goToPublication(publication) {
      this.selectedPublication = publication;
      const index = this.filteredPublications.indexOf(publication);
      const name = publication.Periodista.split(" ").join("-");
      let routeData = this.$router.resolve({
        path: `/publicacion/${index}/periodista/${name}`,
      });
      //window.open(routeData.href, "_blank");
      this.$router.push({ path: `/publicacion/${index}/periodista/${name}` });
    },
    handleFilters(val, property, shortProperty) {
      const chosen = shortProperty ? shortProperty : property.toLowerCase();
      Object.keys(this.filterSelection).forEach((el) => {
        //if (el !== chosen) this.filterSelection[el] = null;
      });
      this.filterPublications(val, property);
    },
    async filterPublications(val, property) {
      this.isLoading = true;
      if (this.search) {
        this.filteredPublications = await _.filter(
          this.allPublications,
          (p) => {
            return (
              p["Título"].includes(this.search) ||
              p.Tema.includes(this.filterSelection.tema) ||
              p.Medio.includes(this.filterSelection.medio) ||
              p.Formato.includes(this.search) ||
              p.FDP.includes(this.search) ||
              p.Periodista.includes(this.search) ||
              p.Archivo.includes(this.search) ||
              p.Plataforma.includes(this.search) ||
              p.Municipio.includes(this.search) ||
              p.Estado.includes(this.search)
            );
          }
        );
      } else {
        this.filteredPublications = this.allPublications;
      }
      this.isLoading = false;
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch("getPublications", { q: "Nevith" });
    this.getFilterOptions();
    this.filteredPublications = this.allPublications;
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
#AdvancedSearch {
  .advanced-search-button {
    color: #141414;
  }

  .advanced-search {
    font-size: 27px;
    width: 50px;
    height: 50px;
    font-weight: 600;
    color: #fff;
    background-color: #000;
    border-radius: 50%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      opacity: 0.9;
    }
  }

  .info {
    border-radius: 50%;
    border: 1px solid #141414;
  }

  .card {
    border: none;
  }

  .pagination {
    .page-item {
      &.active .page-link {
        background-color: #141414;
        border-color: #141414;
        color: white;
      }
      .page-link {
        color: #141414;
      }
    }
  }

  #table {
    font-size: 12px;
    td {
      div {
        overflow-wrap: break-word;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }

  .group {
    position: relative;
    margin: 45px 0;
  }

  textarea {
    resize: none;
  }

  input,
  textarea {
    background: none;
    color: mix(white, #424242, 70%);
    font-size: 18px;
    padding: 10px 10px 10px 5px;
    display: block;
    width: 100%;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid mix(white, #424242, 70%);
    &:focus {
      outline: none;
    }
    &:focus ~ label,
    &:valid ~ label {
      top: -14px;
      font-size: 12px;
      color: #141414;
    }
    &:focus ~ .bar:before {
      width: 100%;
    }
  }

  input[type="password"] {
    letter-spacing: 0.3em;
  }

  label {
    color: mix(white, #424242, 70%);
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 10px;
    transition: 300ms ease all;
  }

  .bar {
    position: relative;
    display: block;
    width: 100%;
    &:before {
      content: "";
      height: 2px;
      width: 0;
      bottom: 0px;
      position: absolute;
      background: #141414;
      transition: 300ms ease all;
      left: 0%;
    }
  }

  .wrap {
    position: absolute;
    right: 0;
    top: 40%;
    width: 100%;
    left: 0;
    margin: 0 auto;
  }

  .select {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    position: relative;
    width: 100%;
  }

  .select-text {
    position: relative;
    font-family: inherit;
    background-color: transparent;
    width: 100%;
    padding: 10px 10px 10px 0;
    font-size: 18px;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  .select-text:focus {
    outline: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
  }

  .select .select-text {
    appearance: none;
    -webkit-appearance: none;
  }

  .select:after {
    position: absolute;
    top: 18px;
    right: 10px;
    width: 0;
    height: 0;
    padding: 0;
    content: "";
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid rgba(0, 0, 0, 0.12);
    pointer-events: none;
  }

  .select-label {
    color: rgba(0, 0, 0, 0.26);
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 10px;
    transition: 0.2s ease all;
  }

  .select-text:focus ~ .select-label,
  .select-text:valid ~ .select-label {
    color: #141414;
    top: -20px;
    transition: 0.2s ease all;
    font-size: 14px;
  }

  .select-bar {
    position: relative;
    display: block;
    width: 100%;
  }

  .select-bar:before,
  .select-bar:after {
    content: "";
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: #141414;
    transition: 0.2s ease all;
  }

  .select-bar:before {
    left: 50%;
  }

  .select-bar:after {
    right: 50%;
  }

  .select-text:focus ~ .select-bar:before,
  .select-text:focus ~ .select-bar:after {
    width: 50%;
  }

  .select-highlight {
    position: absolute;
    height: 60%;
    width: 100px;
    top: 25%;
    left: 0;
    pointer-events: none;
    opacity: 0.5;
  }
}

@media (max-width: 767.98px) {
  #AdvancedSearch {
    .select,
    .select-text,
    .select-bar {
      width: 100% !important;
    }
  }
}
</style>